<div class="content-container clearfix p:24 md:p-32 lg:p-48">
    <div class="grid-container p-24:b md:p-32:b lg:p-48:b">
        <div class="g-12">
            <h3>Nicht gefunden</h3>
            <hr />
        </div>
    </div>
    <div class="grid-container">
        <div class="g-12 p-12:b md:p-16:b lg:p-24:b">
            <p>
                Das Versicherungsprodukt, dass du suchst, existiert nicht, oder die Verbindung zu unserem
                Sicherheitsserver wurde unterbrochen.
            </p>
            <p>Suchst du eines der unten stehenden Produkte? Dann wähle es einfach aus der Liste aus.</p>
        </div>
        <div class="g-6">
            @for (linkGroup of links; track linkGroup) {
                <div class="p-12:v md:p-16:v lg:p-24:v">
                    <h4 class="m-0">{{ linkGroup.description }}</h4>
                    <hr />
                    @if (linkGroup.links.length > 0) {
                        @for (link of linkGroup.links; track link) {
                            <div class="link-group-link">
                                <a
                                    class="p:6 md:p-8 lg:p-12 m-6:b md:m-8:b lg:m-12:b block"
                                    [routerLink]="link.routerLink"
                                    [title]="link.title"
                                    >{{ link.description }}</a
                                >
                            </div>
                        }
                    } @else {
                        <div class="link-group-link">
                            <a
                                class="h4 p:6 md:p-8 lg:p-12 m-6:b md:m-8:b lg:m-12:b block"
                                [routerLink]="linkGroup.rootLink"
                                [title]="linkGroup.description"
                                >{{ linkGroup.description }}</a
                            >
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>
